/* eslint-disable react-refresh/only-export-components */
import { cva, type VariantProps } from "class-variance-authority"
import { Slot } from "radix-ui"
import type { ComponentProps } from "react"
import { cn } from "cn"

const titleVariants = cva("text-labels-primary", {
  variants: {
    size: {
      // 16/24px – Tailwinds `text-base` trifft die Figma-Werte exakt.
      md: "text-base",
    },
    weight: {
      // Figma-Style „Bold" mit Gewicht 700 – deckungsgleich mit `font-bold`.
      bold: "font-bold",
    },
  },
  defaultVariants: {
    size: "md",
    weight: "bold",
  },
})

export type TitleSize = NonNullable<VariantProps<typeof titleVariants>["size"]>

export type TitleWeight = NonNullable<
  VariantProps<typeof titleVariants>["weight"]
>

export type TitleProps = ComponentProps<"h3"> &
  VariantProps<typeof titleVariants> & {
    asChild?: boolean
  }

function Title({
  className,
  size = "md",
  weight = "bold",
  asChild = false,
  ...props
}: TitleProps) {
  const Comp = asChild ? Slot.Root : "h3"

  return (
    <Comp
      data-slot="title"
      data-size={size}
      data-weight={weight}
      className={cn(titleVariants({ size, weight, className }))}
      {...props}
    />
  )
}

export { Title, titleVariants }
